export default {
    ROLE_CASHIER: 'cashier',
    ROLE_MC: 'monitoring-center',
    ROLE_LAWYER: 'lawyer'
}